import Axios from 'axios';

const getDefaultState = () => {
  return {
    internships: [],
    internshipsLoading: false,
    internshipsLoaded: false
  };
};

const state = getDefaultState();

const getters = {
  getCountOfAttachedCities: state => cityId => {
    let count = 0;

    for (var i = 0; i < state.internships.length; i++) {
      if (state.internships[i].city.id == cityId) {
        count += 1;
      }
    }

    return count;
  },

  getCountOfAttachedDepartments: state => departmentId => {
    let count = 0;

    for (var i = 0; i < state.internships.length; i++) {
      if (state.internships[i].department.id == departmentId) {
        count += 1;
      }
    }

    return count;
  }
};

const mutations = {
  SET_INTERNSHIPS: (state, payload) => {
    state.internships = payload;
  },

  SET_INTERNSHIPS_LOADING: (state, payload) => {
    state.internshipsLoading = payload;
  },

  SET_INTERNSHIPS_LOADED: (state, payload) => {
    state.internshipsLoaded = payload;
  },

  REMOVE_INTERNSHIP: (state, internshipId) => {
    const index = state.internships.findIndex(x => x.id == internshipId);

    if (index !== -1) {
      state.internships.splice(index, 1);
    }
  },

  RESET_STATE_INDEX: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchInternships({ commit }) {
    commit('SET_INTERNSHIPS_LOADED', false);
    commit('SET_INTERNSHIPS_LOADING', true);

    await Axios.get('/1.0/spec-public/mars/miep/vacancy')
      .then(response => {
        commit('SET_INTERNSHIPS', response.data.data);
        commit('SET_INTERNSHIPS_LOADED', true);
      })
      .finally(() => {
        commit('SET_INTERNSHIPS_LOADING', false);
      });
  },

  async attachInternship({ commit, dispatch }, payload) {
    commit('SET_INTERNSHIPS_LOADING', true);

    await Axios.post('/1.0/spec-private/mars/miep/vacancy', payload)
      .then(() => {
        dispatch('fetchInternships');
      })
      .finally(() => {
        commit('SET_INTERNSHIPS_LOADING', false);
      });
  },

  async deAttachInternship({ commit }, internshipId) {
    commit('SET_INTERNSHIPS_LOADING', true);

    await Axios.delete(`/1.0/spec-private/mars/miep/vacancy/${internshipId}`)
      .then(() => {
        commit('REMOVE_INTERNSHIP', internshipId);
      })
      .finally(() => {
        commit('SET_INTERNSHIPS_LOADING', false);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
